export default __webpack_public_path__ + "static/media/Students.2cd184d4.xls";